import { render, staticRenderFns } from "./add-cat-ii-requirement.vue?vue&type=template&id=5a540f76"
import script from "./add-cat-ii-requirement.vue?vue&type=script&lang=js"
export * from "./add-cat-ii-requirement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports